if (!customElements.get('td-aspen-media-video')) {
  class TdAspenMediaVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-td-media-play-button]');

      if (!this.video || !this.playButton) {
        return;
      }

      this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
      this.handleEnded = this.handleEnded.bind(this);
      this.handleVideoClick = this.handleVideoClick.bind(this);

      this.playButton.addEventListener('click', this.handlePlayButtonClick);
      this.video.addEventListener('ended', this.handleEnded);
      this.video.addEventListener('click', this.handleVideoClick);
    }

    disconnectedCallback() {
      this.playButton?.removeEventListener('click', this.handlePlayButtonClick);
      this.video?.removeEventListener('ended', this.handleEnded);
      this.video?.removeEventListener('click', this.handleVideoClick);
    }

    setPlayingState(isPlaying) {
      this.playButton.classList.toggle('playing', isPlaying);
      this.classList.toggle('playing', isPlaying);
    }

    handlePlayButtonClick(event) {
      event.preventDefault();

      if (this.video.paused) {
        this.video.play();
        this.setPlayingState(true);
      } else {
        this.video.pause();
        this.setPlayingState(false);
      }
    }

    handleEnded() {
      this.video.currentTime = 0;
      this.setPlayingState(false);
    }

    handleVideoClick() {
      if (!this.video.paused) {
        this.video.pause();
        this.setPlayingState(false);
      }
    }
  }

  customElements.define('td-aspen-media-video', TdAspenMediaVideo);
}
